import {inject, InjectionKey} from 'vue'
import { SplitPlugin } from '@/shims-split'

export const splitInjectionKey = Symbol('Plugin for Split, our integration for feature flag management and experimentation.') as InjectionKey<SplitPlugin>

export const useSplit = (): SplitPlugin => {
  return inject<SplitPlugin>(splitInjectionKey)
}
